import * as types from './types';
import communityQueries from '../queries/community';
import commentQueries from '../queries/comment';
import postQueries from '../queries/post';
import tagQueries from '../queries/tag';
import userQueries from '../queries/user';
import badgeQueries from '../queries/badge';
import communityMediaHelper from '../../../helpers/request/communityMedia';

export const fetchList = ({ commit }) => communityQueries.fetchUserCommunities()
  .then((response) => {
    const { data } = response;
    commit(types.SET_COMMUNITIES_LIST, data.user_communities);
  });

export const setActive = ({ commit }, communityData) => {
  const { community, ...communityUser } = communityData;

  commit(types.SET_ACTIVE_COMMUNITY, community);
  commit(types.SET_ACTIVE_COMMUNITY_USER, communityUser);
};

export const fetchTags = ({ commit }, communityData) =>
  tagQueries.fetchTags(communityData)
    .then((response) => {
      const { data } = response;
      commit(types.SET_TAGS, data.community_all_tags);
    });

export const resetPosts = ({ commit }) =>
  commit(types.SET_POSTS, []);

export const countAsidePosts = ({ commit }, communityData) =>
postQueries.countAsidePosts(communityData)
  .then((response) => {
    const { data } = response;
    commit(types.SET_ASIDE_POSTS_COUNTER, data.count_community_aside_posts);
  });

export const fetchAsidePosts = ({ commit }, communityData) =>
postQueries.fetchAsidePosts(communityData)
  .then((response) => {
    const { data } = response;
    commit(types.SET_ASIDE_POSTS, data.community_aside_posts);
  });

export const fetchAndCountAsidePosts = ({ dispatch, state }) => {
  const communityId = state.activeCommunity.id;

  dispatch('fetchAsidePosts', { communityId });
  dispatch('countAsidePosts', { communityId });
};

export const appendAsidePinnedPost = ({ commit }, postItem) =>
  commit(types.APPEND_ASIDE_POST, postItem);

export const updatePostOnAsideList = ({ commit }, postItem) =>
  commit(types.UPDATE_POST_ON_ASIDE_LIST, postItem);

const filterParams = state => ({
  communityId: state.activeCommunity.id,
  tag: state.postFilter.tag,
  moderationState: state.postFilter.moderationState,
  search: state.postFilter.search,
  postsOrderBy: state.postsOrderBy,
});

export const countPosts = ({ commit, state }) => {
  const params = filterParams(state);

  return postQueries.countPosts(params)
    .then(({ data }) => {
      commit(types.SET_POSTS_COUNTER, data.count_community_posts);
    });
};

export const fetchPosts = ({ commit, state }, page = 1) => {
  let params = filterParams(state);
  params = { ...params, page };

  return postQueries.fetchPosts(params)
    .then((response) => {
      const { data } = response;
      commit(types.SET_POSTS, data.community_posts);
    });
};

export const fetchAppendPosts = ({ commit, state }, page = 1) => {
  let params = filterParams(state);
  params = { ...params, page };

  return postQueries.fetchPosts(params)
    .then(({ data }) => {
      commit(types.APPEND_POSTS, data.community_posts);
      return data.community_posts;
    });
};

export const fetchPost = ({ commit }, postId) =>
  postQueries.fetchPost(postId)
    .then((response) => {
      const { data } = response;
      commit(types.SET_ACTIVE_POST, data.community_post);
    });

export const setActivePost = ({ commit }, postData) =>
  commit(types.SET_ACTIVE_POST, postData);

export const createPost = ({ commit, dispatch }, postData) => {
  postQueries.createPost(postData)
    .then(() => {
      commit(types.RESET_POST_FILTER);
      dispatch('fetchAndCountPosts');

      if (postData.tagsChanged) {
        dispatch('fetchPopularTags');
      }
    });
};

export const fetchAndCountPosts = ({ dispatch }) => {
  dispatch('fetchPosts');
  dispatch('countPosts');
};

export const postsOrderBy = ({ commit, state, dispatch }, order) => {
  commit(types.SET_POSTS_ORDER_BY, order);
  dispatch('fetchPosts');
};

export const updatePost = ({ _ }, post) => postQueries.updatePost(post);

export const updatePostOnList = ({ commit }, postId) =>
  postQueries.fetchPost(postId)
    .then((response) => {
      const { data } = response;
      commit(types.UPDATE_POST_ON_LIST, data.community_post);
    });


export const updateModerationState = ({ _ }, data) => postQueries.updateModerationState(data);

export const fetchPostComments = ((post) => {
  post.commentId = null;
  return commentQueries.fetchPostComments(post);
});

export const fetchAndAppendPostComments = ({ commit }, post) =>
  fetchPostComments(post)
    .then((response) => {
      const { data } = response;
      commit(types.APPEND_POST_COMMENTS, data.community_post_comments);
      return data.community_post_comments;
    });

export const fetchAndSetPostComments = ({ commit }, post) =>
  fetchPostComments(post)
    .then((response) => {
      commit(types.SET_POST_COMMENTS, response.data.community_post_comments);
    });

export const countPostComments = ({ commit }, postId) =>
  commentQueries.countPostComments(postId)
    .then((response) => {
      const { data } = response;
      commit(types.SET_POST_COMMENTS_COUNTER, data.count_community_post_comments);
    });

export const setActiveComment = ({ commit }, commentData) =>
  commit(types.SET_ACTIVE_COMMENT, commentData);

export const resetActiveComment = ({ commit }) =>
  commit(types.RESET_ACTIVE_COMMENT);

export const createComment = ({ rootState, dispatch, state }, commentData) => {
  const postId = rootState.route.params.postId || state.activePost.id;
  commentData.postId = postId;

  return commentQueries.createComment(commentData).then((response) => {
    dispatch('countPostComments', postId);
    dispatch('updatePostOnList', postId);
    return response;
  });
};

export const updateComment = ({ _ }, commentData) =>
  commentQueries.updateComment(commentData);

export const destroyComment = ({ state, rootState, dispatch }) => {
  const postId = rootState.route.params.postId;
  return commentQueries
    .destroyComment(state.activeComment.id)
    .then(() => {
      if (state.activeComment.comment_id) {
        dispatch('fetchCommentById', state.activeComment.comment_id);
      }

      dispatch('fetchPost', postId);
    });
};

export const fetchCommentReplies = ({ commit }, { comment, postId, page, reset }) => {
  const commentData = { ...comment };
  commentData.postId = postId;
  commentData.page = page;
  commentData.commentId = comment.id;

  return commentQueries.fetchPostComments(commentData)
    .then((response) => {
      const { data } = response;
      commit(types.SET_REPLIES_TO_COMMENT, {
        replies: data.community_post_comments,
        comment,
        reset: reset || false,
      });
    });
};

export const setActiveTerm = ({ commit }, communityTerm) =>
  commit(types.SET_ACTIVE_COMMUNITY_TERMS, communityTerm);

export const acceptUseTerms = ({ state }) => {
  const communityId = Number(state.activeCommunityTerms.id);
  return communityQueries.acceptUseTerms(communityId);
};

export const fetchById = ({ dispatch }, { communityId, showLoader }) =>
  communityQueries.fetchById(communityId, showLoader)
    .then((response) => {
      const { data } = response;
      const userCommunity = data.user_community;
      dispatch('setActive', userCommunity);
    });

export const likePost = ({ commit }, id) => postQueries.likePost(id);

export const likeComment = ({ dispatch }, comment) => commentQueries
  .like(comment.id)
  .then((response) => {
    const data = response.data.likeCommunityPostComment;
    const action = !comment.comment_id ? 'updatePostCommentList' : 'updateReplyList';
    dispatch(action, data.community_post_comment);
  });

export const updateActivePost = ({ commit }, post) => commit(types.SET_ACTIVE_POST, post);

export const updatePostList = ({ commit }, post) => commit(types.UPDATE_POST_LIST, post);

export const updateCommentModerationState = ({ _ }, data) =>
  commentQueries.updateModerationState(data);

export const updatePostCommentList = ({ commit }, comment) =>
  commit(types.UPDATE_POST_COMMENT_ON_LIST, comment);

export const updateReplyList = ({ commit }, reply) =>
  commit(types.UPDATE_REPLY_ON_LIST, reply);

export const addReplyOnList = ({ commit }, reply) =>
  commit(types.ADD_REPLY_ON_LIST, reply);

export const changeUserTheme = ({ rootState, commit }, theme) => {
  const { communityId } = rootState.route.params;

  return communityQueries.changeUserTheme({ communityId, theme }).then((response) => {
    const communityUser = response.data.changeCommunityUserTheme.community_user;

    commit(types.SET_ACTIVE_COMMUNITY_USER, communityUser);
  });
};

export const fetchPopularCommunityBookmarkedTags = ({ commit, rootState, state }) => {
  const { communityId } = rootState.route.params;

  return tagQueries.fetchPopularCommunityBookmarkedTags(communityId, state.postFilter)
    .then((response) => {
      const { data } = response;
      commit(types.SET_POPULAR_TAGS, data.popular_community_bookmarked_tags);
    });
};

export const fetchPopularTags = ({ commit, rootState, state }) => {
  const { communityId } = rootState.route.params;

  return tagQueries.fetchPopularTags(communityId, state.postFilter)
    .then((response) => {
      const { data } = response;
      commit(types.SET_POPULAR_TAGS, data.popular_community_tags);
    });
};

export const setTagFilter = ({ commit }, tags) =>
  commit(types.SET_TAG_FILTER, tags);

export const setSearchFilter = ({ commit }, search) =>
  commit(types.SET_SEARCH_FILTER, search);

export const setMemberSearch = ({ commit }, search) =>
  commit(types.SET_USER_SEARCH, search);

export const setModerationStateFilter = ({ commit }, moderationState) =>
  commit(types.SET_MODERATION_STATE_FILTER, moderationState);

export const toggleModerationStateFilter = ({ commit }, moderationState) =>
  commit(types.TOGGLE_MODERATION_STATE_FILTER, moderationState);

export const resetPostFilter = ({ commit }) => commit(types.RESET_POST_FILTER);

export const destroyPost = ({ _ }, id) => postQueries.destroy(id);

export const fetchCommentById = ({ dispatch }, commentId) =>
  commentQueries.fetchById(commentId).then((response) => {
    dispatch('updatePostCommentList', response.data.community_post_comment);
  });

export const uploadPostMedia = ({ _ }, uploadData) => communityMediaHelper.upload(uploadData);

export const uploadPostImage = ({ _ }, uploadData) =>
  communityMediaHelper.uploadPostImage(uploadData);

export const setPostUpload = ({ commit }, progress) => commit(types.SET_POST_UPLOAD, progress);

export const resetPostUpload = ({ commit }) => commit(types.RESET_POST_UPLOAD);

export const fetchComments = ({ commit, rootState, dispatch }, params) => {
  const { communityId } = rootState.route.params;

  dispatch('countComments', params.moderationState);

  return commentQueries
    .fetchCommunityComments(communityId, params)
    .then((response) => {
      const { data } = response;
      commit(types.SET_COMMENTS, data.community_comments);
    });
};

export const countComments = ({ commit, rootState }, moderationState) => {
  const { communityId } = rootState.route.params;

  return commentQueries
    .countCommunityComments(communityId, moderationState)
    .then((response) => {
      const { data } = response;
      commit(types.SET_TOTAL_COMMENTS, data.count_community_comments);
    });
};

export const updateCommentList = ({ commit }, comment) =>
  commit(types.UPDATE_COMMENT_ON_LIST, comment);

export const changeMobileSidebar = ({ commit }, data) =>
  commit(types.CHANGE_MOBILE_SIDEBAR, data);

export const followPost = ({ _ }, postId) => postQueries.follow(postId);

export const unfollowPost = ({ _ }, postId) => postQueries.unfollow(postId);

export const fetchUsers = ({ commit, rootState, state }, page = 1) => {
  const { communityId } = rootState.route.params;
  const { usersOrderBy, userFilter } = state;

  return userQueries.fetch(communityId, page, usersOrderBy, userFilter)
    .then((response) => {
      const { data } = response;
      commit(types.SET_USERS, data.community_users);
    });
};

export const countUsers = ({ commit, state, rootState }) => {
  const { communityId } = rootState.route.params;
  const { userFilter } = state;

  userQueries.getCount(parseInt(communityId, 10), userFilter)
    .then((response) => {
      const { data } = response;
      commit(types.SET_USERS_COUNTER, data.count_community_users);
    });
};

export const searchUsers = ({ _ }, search) => userQueries.searchUsers(search);

export const updateUserState = ({ _ }, userData) => userQueries.updateState(userData);

export const updateUserStateOnList = ({ commit }, userState) =>
  commit(types.UPDATE_USER_STATE_ON_LIST, userState);

export const usersOrderBy = ({ commit }, order) =>
  commit(types.SET_USERS_ORDER_BY, order);

export const setActiveUser = ({ commit }, communityUser) =>
  commit(types.SET_ACTIVE_COMMUNITY_USER, communityUser);

export const resetActiveUser = ({ commit }) => commit(types.SET_ACTIVE_COMMUNITY_USER, {});

export const toggleAsReadNotification = ({ commit, dispatch, rootState }, notification) =>
  userQueries
    .updateReadNotification(notification.id, !notification.read)
    .then((response) => {
      const { data } = response;
      commit(types.UPDATE_READ_NOTIFICATION, data.updateReadNotification.community_notifications);

      const { communityId } = rootState.route.params;
      dispatch('fetchById', { communityId, showLoader: false });
    });

export const markAllAsReadNotification = ({ commit, dispatch, rootState }) => {
  const { communityId } = rootState.route.params;

  userQueries
    .markAllAsReadNotification(communityId)
    .then(() => {
      commit(types.MARK_ALL_AS_READ_NOTIFICATION);
      dispatch('fetchById', { communityId, showLoader: false });
    });
};

export const fetchUserNotifications = ({ commit, rootState }, page = 1) => {
  const { communityId } = rootState.route.params;

  return userQueries
    .fetchNotifications(communityId, page)
    .then((response) => {
      const { data } = response;
      commit(types.SET_USER_NOTIFICATIONS, {
        notifications: data.community_user_notifications,
        page,
      });
    });
};

export const fetchTotalUserNotifications = ({ commit, rootState }) => {
  const { communityId } = rootState.route.params;

  return userQueries
    .fetchTotalNotifications(communityId)
    .then((response) => {
      const { data } = response;
      commit(types.SET_TOTAL_USER_NOTIFICATIONS, data.count_community_user_notifications);
    });
};

export const updateEmailSettings = ({ commit, state }, kinds) => {
  const communityUserId = state.activeCommunityUser.id;

  return userQueries.updateEmailSettings({ kinds, communityUserId })
    .then((response) => {
      const { data } = response;
      const communityUser = data.updateCommunityUserEmailSettings.community_user;

      commit(types.UPDATE_USER_EMAIL_SETTINGS_ON_LIST, communityUser);
    });
};

export const createPostBookmark = ({ _ }, postId) => postQueries.createBookmark(postId);

export const removePostBookmark = ({ _ }, postId) => postQueries.removeBookmark(postId);

export const countBookmarkedPosts = ({ commit, state }) => {
  const params = filterParams(state);

  return postQueries.countBookmarkedPosts(params)
    .then(({ data }) => {
      commit(types.SET_POSTS_COUNTER, data.count_community_bookmark_posts);
    });
};

export const fetchBookmarkedPosts = ({ commit, state }, page = 1) => {
  let params = filterParams(state);
  params = { ...params, page };

  return postQueries.fetchBookmarkedPosts({ ...params, page })
    .then((response) => {
      const { data } = response;
      commit(types.SET_POSTS, data.community_bookmark_posts);
    });
};

export const fetchAppendBookmarkedPosts = ({ commit, state }, page = 1) => {
  let params = filterParams(state);
  params = { ...params, page };

  return postQueries.fetchBookmarkedPosts({ ...params, page })
    .then((response) => {
      const { data } = response;
      commit(types.APPEND_POSTS, data.community_bookmark_posts);
      return data.community_bookmark_posts;
    });
};

export const getCommunityUserProfile = ({ commit, state }, communityUserId) => {
  const isSameUser = communityUserId === state.activeCommunityUser.id;
  return userQueries.getProfileData(communityUserId, isSameUser).then((response) => {
    const { data } = response;
    const communityUser = data.community_user_profile_data;

    commit(types.SET_COMMUNITY_USER_PROFILE, communityUser);
  });
};

export const resetCommunityUserProfile = ({ commit }) => commit(types.RESET_COMMUNITY_USER_PROFILE);

export const addPostCommentToList = ({ commit }, commentId) => commentQueries.fetchById(commentId)
  .then((response) => {
    commit(types.ADD_COMMENT_TO_LIST, response.data.community_post_comment);
  });

export const loadUniqueComment = ({ commit, dispatch, rootState }, commentId) =>
  commentQueries.fetchById(commentId)
    .then((response) => {
      const postComment = response.data.community_post_comment;
      const { postId } = rootState.route.params;

      if (postComment.comment_id) {
        return dispatch('loadUniquePrimaryComment', postComment);
      }

      commit(types.ADD_COMMENT_TO_LIST, postComment);

      return dispatch('fetchCommentReplies', {
        comment: postComment,
        postId,
        page: 1,
        reset: true,
      });
    });

export const loadUniquePrimaryComment = ({ commit }, replyComment) =>
  commentQueries.fetchById(replyComment.comment_id)
    .then(({ data }) => {
      const parentComment = data.community_post_comment;
      commit(types.ADD_COMMENT_TO_LIST, parentComment);
      commit(types.SET_REPLIES_TO_COMMENT, {
        comment: parentComment,
        replies: [replyComment],
        reset: true,
      });
    });

export const resetPostComments = ({ commit }) => commit(types.SET_POST_COMMENTS, []);

export const resetCommentReplies = ({ commit }) => commit(types.RESET_COMMENT_REPLIES);

export const pin = ({ _ }, itemId) => postQueries.pin(itemId);

export const pinAside = ({ _ }, itemId) => postQueries.pinAside(itemId);

export const getBadgesList = ({ rootState, commit }) => {
  const { communityId } = rootState.route.params;

  return badgeQueries.getList(communityId).then((response) => {
    commit(types.SET_BADGES, response.data.community_badges);
  });
};

export const assignBadges = ({ commit, state }, { userId, badges, isSameUser }) =>
  userQueries.assignBadges({ userId, badges }, isSameUser)
    .then((response) => {
      const data = response.data.assignBadges.community_user;

      if (state.communityUserProfile.id) {
        commit(types.SET_COMMUNITY_USER_PROFILE, data);
      }

      commit(types.UPDATE_USER_BADGES_ON_LIST, data);
    });

export const setReplyingComment = ({ commit }, comment) =>
  commit(types.SET_REPLYING_COMMENT, comment);

export const toggleBestComment = ({ commit }, comment) => commentQueries.toggleBestComment(comment)
  .then((response) => {
    const { data } = response;
    const { toggleBestComment } = data;
    commit(types.UPDATE_POST_COMMENT_ON_LIST, toggleBestComment.community_post_comment);
  });



// WEBPACK FOOTER //
// ./src/screens/Community/store/actions.js